import React from 'react';
import { Users, ShoppingCart, BarChart3, MessageCircle, Smartphone, Shield } from 'lucide-react';

export const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Gestión de Clientes',
      description: 'Organiza tu base de clientes con información completa, historial de compras y segmentación inteligente.',
      color: 'text-blue-600'
    },
    {
      icon: <ShoppingCart className="w-8 h-8" />,
      title: 'Control de Ventas',
      description: 'Registra ventas, facturas y pagos. Genera reportes de rentabilidad y análisis de rendimiento.',
      color: 'text-green-600'
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: 'Inventario Inteligente',
      description: 'Controla stock, alertas de reposición y análisis de rotación. Precios con IVA incluido automáticamente.',
      color: 'text-purple-600'
    },
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: 'WhatsApp Business',
      description: 'Integración nativa con WhatsApp. Gestiona conversaciones, envíos masivos y respuestas automáticas.',
      color: 'text-green-500'
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: 'App Móvil',
      description: 'Accede a tu negocio desde cualquier lugar. Interfaz optimizada para celulares y tablets.',
      color: 'text-orange-600'
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Seguridad y Backup',
      description: 'Datos protegidos con encriptación. Backups automáticos y cumplimiento de normativas locales.',
      color: 'text-red-600'
    }
  ];

  return (
    <section id="funciones" className="py-16 md:py-20 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            🚀 Todo lo que tu PyME necesita en una plataforma
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Diseñado específicamente para las necesidades de pequeños negocios en Latinoamérica. Simple,
            potente y accesible desde cualquier dispositivo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-100 shadow-sm p-8 text-center md:text-left hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className={`${feature.color} mb-4 flex justify-center md:justify-start`}>{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-[15px]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
